import { useContext } from 'react';

import { DialogContext } from '../types';

export function useDialog() {
	return useContext(DialogContext);
}
